module.exports = __webpack_public_path__ + "img/elros.822883ac.png";